import React from "react";
import LogoWithText from "@/components/controls/LogoWithText";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import { useTranslation } from "react-i18next";
import FullpageBackground from "./FullpageImage.svg";

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  additionalInfo?: React.ReactNode;
  buttonLabel?: string;
  onButtonClick: () => void;
}

const FullpageMessage: React.FC<Props> = ({
  title,
  subtitle = "",
  additionalInfo = "",
  buttonLabel = null,
  onButtonClick = () => history.back()
}) => {
  const { t } = useTranslation();
  const updatedButtonLabel = buttonLabel || t("FullpageMessage.backButton");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {/* @ts-ignore */}
      <FullpageBackground className="absolute inset-0 w-full h-full z-[-10]" />
      <div className="absolute top-4 left-4">
        <LogoWithText isExpanded label={t("dreamhub")} />
      </div>
      <div className="max-w-md text-center">
        <Text className="mb-4" as="p" variant="title3H1">
          {title}
        </Text>
        {subtitle && (
          <Text className="mb-6 whitespace-pre-wrap" as="p" variant="body">
            {subtitle}
          </Text>
        )}
        {additionalInfo && (
          <Text className="mb-8" as="p" variant="smBodySecondary">
            {additionalInfo}
          </Text>
        )}
        <Button variant={"primary"} onClick={onButtonClick}>
          {updatedButtonLabel}
        </Button>
      </div>
    </div>
  );
};

export default FullpageMessage;
